var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#copy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.665 5.333V3.467c0-.747 0-1.12-.145-1.406a1.33 1.33 0 0 0-.583-.582c-.285-.146-.658-.146-1.405-.146H3.465c-.746 0-1.12 0-1.405.146-.25.127-.455.331-.583.582-.145.286-.145.659-.145 1.406v5.066c0 .747 0 1.12.145 1.406.128.25.332.454.583.582.285.146.659.146 1.405.146h1.867m2.133 4h5.067c.747 0 1.12 0 1.405-.146.251-.128.455-.332.583-.582.145-.286.145-.659.145-1.406V7.467c0-.747 0-1.12-.145-1.406a1.33 1.33 0 0 0-.583-.582c-.285-.146-.658-.146-1.405-.146H7.465c-.746 0-1.12 0-1.405.146-.25.127-.455.331-.583.582-.145.286-.145.659-.145 1.406v5.066c0 .747 0 1.12.145 1.406.128.25.332.454.583.582.285.146.659.146 1.405.146"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCopy;